export default {
  message: {
    "strid1": "Login"
  }
}
